// #40 - the principal's queue of the agency's requests held for a countersignature
// (AOC/LOA). Any principal at the agency can review and sign these; the list is
// scoped to the principal's own agency by the API. Signing releases the hold and
// creates the held Freshservice ticket(s).
import { useEffect, useState } from "react";
import {
  Alert,
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { Title } from "react-admin";
import contractRequestService from "../../../services/contract-request.service";

const agentName = (r) =>
  [r.firstName, r.lastName].filter(Boolean).join(" ").trim() || r.npn || "Agent";

const AwaitingCountersignature = () => {
  const [rows, setRows] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    contractRequestService
      .awaitingCountersignature()
      .then(setRows)
      .catch(() => setError("Could not load the countersignature queue."));
  }, []);

  return (
    <Box sx={{ maxWidth: 1000, mt: 2 }}>
      <Title title="Awaiting Countersignature" />
      <Typography variant="h5" gutterBottom>
        Awaiting Countersignature
      </Typography>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        Your agents' LOA/AOC requests are on hold until a principal at your agency
        countersigns the DocuSign. Review each one and sign it to release the hold.
      </Typography>

      {error && <Alert severity="error">{error}</Alert>}

      {rows && rows.length === 0 && (
        <Alert severity="info" sx={{ mt: 2 }}>
          Nothing is awaiting your countersignature right now.
        </Alert>
      )}

      {rows && rows.length > 0 && (
        <TableContainer component={Paper} sx={{ mt: 2 }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell><strong>Agent</strong></TableCell>
                <TableCell><strong>Upline</strong></TableCell>
                <TableCell><strong>Carriers</strong></TableCell>
                <TableCell align="right"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((r) => (
                <TableRow key={r._id} hover>
                  <TableCell>{agentName(r)}</TableCell>
                  <TableCell>{r.paymentUpline || "-"}</TableCell>
                  <TableCell>{(r.contracts || []).length}</TableCell>
                  <TableCell align="right">
                    <Button variant="contained" href={`/countersign/${r._id}`}>
                      Review &amp; sign
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default AwaitingCountersignature;
